import { gql } from '@apollo/client';

// ===== Analytics projects =====
// A project groups workflows; the list query nests them so the sidebar can
// render both levels in one round-trip.

export const WORKFLOW_FIELDS = `
  id
  projectId
  title
  status
  error
  finishedAt
`;

export const ANALYTICS_PROJECTS = gql`
  query AnalyticsProjects {
    analyticsProjects {
      id
      name
      workflows {
        ${WORKFLOW_FIELDS}
      }
    }
  }
`;

export const CREATE_ANALYTICS_PROJECT = gql`
  mutation CreateAnalyticsProject($input: CreateAnalyticsProjectInput!) {
    createAnalyticsProject(input: $input) {
      id
      name
    }
  }
`;

export const UPDATE_ANALYTICS_PROJECT = gql`
  mutation UpdateAnalyticsProject($input: UpdateAnalyticsProjectInput!) {
    updateAnalyticsProject(input: $input) {
      id
      name
    }
  }
`;

export const DELETE_ANALYTICS_PROJECT = gql`
  mutation DeleteAnalyticsProject($input: DeleteAnalyticsProjectInput!) {
    deleteAnalyticsProject(input: $input) {
      id
    }
  }
`;
